/* @flow */
import * as React from 'react';
import classnames from 'classnames/bind';
import tsLogo from 'trustar/img/ts-logo-color.svg';

import s from './EnclaveIcon.styl';
const cx = classnames.bind(s);

type EnclaveIconProps = {
  enclave: {
    color?: string,
    name?: string,
    iconUrl?: string,
  },
  className?: string,
};

/**
 * Render an icon given an enclave object.
 *
 * NOTE: This if 'Community' logic is not great since it's relying on a name
 * that we haven't standardized on the back end. For now it's just made up. If
 * community really is going to be an enclave we should make that a reality
 * rather than just having the UI represent it as such
 *
 * NOTE: I'm using class components here so that we can wrap these in tooltips.
 * The current tooltip implementation relies on refs which don't work on
 * functional components.
 */
export class EnclaveIcon extends React.PureComponent {
  props: EnclaveIconProps;

  render() {
    const { className, enclave } = this.props;
    let { name, color, iconUrl } = enclave;
    // See NOTE
    if (!name) {
      iconUrl = tsLogo;
    }

    if (!color) color = 'gray'; // default if color is undefined for some reason

    return iconUrl ? (
      <div className={cx('container', className)}>
        <img src={iconUrl} alt='Enclave icon' />
      </div>
    ) : (
      <div className={cx('container', 'default', className, color)}>
        <div className={cx('innerSlice')}></div>
      </div>
    );
  }
}

/* Shows placeholder icon to fill for 'more' enclaves which overflow container,
 * e.g. 5+, 11+, 27+ etc. */
export class AdditionalEnclavesIcon extends React.PureComponent {
  props: {
    count: number,
    className?: string,
  };
  render() {
    const { count, className } = this.props;
    return (
      <div className={cx('container', 'default', 'teal', className)}>
        <span className={cx('num-of-additional-enclaves')}>+{count}</span>
        <div className={cx('innerSlice')} />
      </div>
    );
  }
}

/* Icon for Community */
export class CommunityIcon extends React.PureComponent {
  render() {
    return (
      <EnclaveIcon
        {...this.props}
        enclave={{ iconUrl: tsLogo, name: 'Community' }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./web_modules/trustar/components/EnclaveIcon.js